import React, { useState } from "react";

import CalenderIcon from "@components/Icons/CalenderIcon";
import SearchSelect from "@components/SearchSelect";

const CALENDAR_OPTIONS = [
    { value: "google", label: "Google Calendar" },
    { value: "outlook", label: "Outlook" },
    { value: "ical", label: "Apple Calendar" },
];


const CalendarPicker = ({ calendarLinks, movieTitle }) => {
    const [selectedCalendar, setSelectedCalendar] = useState(null);

    if (!calendarLinks) return null;

    const handleCalendarSelect = (selectedOption) => {
        if (!selectedOption) return;

        const { value } = selectedOption;

        if (value === "google") {
            window.open(calendarLinks.google, "_blank");
        } else if (value === "outlook") {
            window.open(calendarLinks.outlook, "_blank");
        } else if (value === "ical") {
            const link = document.createElement("a");
            link.href = calendarLinks.ical;
            link.download = `${movieTitle}.ics`;
            link.click();
        }

        setSelectedCalendar(null);
    };

    return (
        <div className="confirmation__calendar-wrapper">
            <span className="confirmation__calendar-icon">
                <CalenderIcon className="confirmation__calendar-svg" />
            </span>
            <SearchSelect
                placeholder="Add to your calendar"
                aria-label="Add to your calendar"
                value={selectedCalendar}
                options={CALENDAR_OPTIONS}
                onChange={handleCalendarSelect}
                isClearable={true}
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                openMenuOnClick={true}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
            />
        </div>
    );
};

export default CalendarPicker;
